/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'damage': {
    width: 146,
    height: 243,
    viewBox: '0 0 146 243',
    data: '<defs/><path pid="0" id="damage" class="cls-1" d="M1231 318.35a10.839 10.839 0 0 0-.09-1.507l-12.17-97.2A12.154 12.154 0 0 0 1206.67 209h-97.34a12.161 12.161 0 0 0-12.07 10.643l-12.17 97.2a10.839 10.839 0 0 0-.09 1.507 73 73 0 0 0 60.83 71.8v37.55h-36.5V452h97.34v-24.3h-36.5v-37.547A73 73 0 0 0 1231 318.35zm-121.65.712l10.72-85.762h27.36l-11.72 17.56a12.124 12.124 0 0 0 1.52 15.324l15.73 15.716-15.73 15.71 17.21 17.174 24.33-24.3a12.13 12.13 0 0 0 0-17.174l-17.28-17.253 15.19-22.757h19.25l10.74 85.762a48.666 48.666 0 0 1-97.32 0z" transform="translate(-1085 -209)"/>'
  }
})
